import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { emailRegex } from '@app/@core/services/auth.service';

const phoneRegex = /^\+?\d{8,15}$/;

export const PASSWORD_RULES = [
  {
    key: 'passwordMinLength',
    label: 'Password should be 8 characters or more',
  },
  {
    key: 'passwordUppercase',
    label: 'it should contain at least 1 uppercase character',
  },
  {
    key: 'passwordLowercase',
    label: 'it should contain at least 1 lowercase character',
  },
  { key: 'passwordDigit', label: 'it should contain at least 1 number' },
  {
    key: 'passwordSpecial',
    label: 'it should contain at least 1 special letter',
  },
];

const trimmed = (control: AbstractControl): string =>
  typeof control.value === 'string' ? control.value.trim() : '';

export const passwordRulesValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const value: string = control.value ?? '';
  if (!value) return null;

  const errors: ValidationErrors = {};
  if (value.length < 8) errors.passwordMinLength = true;
  if (!/[A-Z]/.test(value)) errors.passwordUppercase = true;
  if (!/[a-z]/.test(value)) errors.passwordLowercase = true;
  if (!/\d/.test(value)) errors.passwordDigit = true;
  if (!/[^A-Za-z0-9]/.test(value)) errors.passwordSpecial = true;

  return Object.keys(errors).length ? errors : null;
};

export const notBlankValidator: ValidatorFn = (control: AbstractControl) =>
  trimmed(control) ? null : { required: true };

export const trimmedEmailValidator: ValidatorFn = (
  control: AbstractControl,
) => {
  const value = trimmed(control);
  if (!value) return { required: true };
  return emailRegex.test(value) ? null : { email: true };
};

export const emailOrPhoneValidator: ValidatorFn = (
  control: AbstractControl,
) => {
  const value = trimmed(control);
  if (!value) return { required: true };
  return emailRegex.test(value) || phoneRegex.test(value)
    ? null
    : { emailOrPhone: true };
};

export function matchControlValidator(otherControlName: string): ValidatorFn {
  return (control: AbstractControl) => {
    const other = control.parent?.get(otherControlName);
    if (!other || !control.value) return null;
    return other.value === control.value ? null : { mismatch: true };
  };
}
